<div
  class="loading-container"
  [class.loading-container--sign]="isSignJourney"
  role="status"
  aria-live="polite"
  aria-busy="true">
  <div class="loading-content" [class.loading-content--sign]="isSignJourney">
    <div class="loading-header">
      <div class="loading-header-icon-wrapper">
        <img *ngIf="useSvgIcon" [src]="svgIconPath" alt="" class="loading-header-icon-img" />
        <i *ngIf="!useSvgIcon" class="fas {{iconClass}} loading-header-icon" aria-hidden="true"></i>
      </div>
      <div class="loading-header-text">
        <h3 class="loading-header-title">{{titulo}}</h3>
        <p class="loading-header-sub" *ngIf="isSignJourney && docProgressLabel">{{ docProgressLabel }}</p>
      </div>
    </div>

    <div class="loading-body" [class.loading-body--sign]="isSignJourney">
      <!-- Visual clásico (no firma) -->
      <div class="loading-visual" *ngIf="!isSignJourney" aria-hidden="true">
        <div class="loading-orbit">
          <span class="loading-orbit-ring loading-orbit-ring--outer"></span>
          <span class="loading-orbit-ring loading-orbit-ring--inner"></span>
          <span class="loading-orbit-dot"></span>
        </div>
        <div class="loading-core">
          <i class="fas {{ coreIconClass }}" aria-hidden="true"></i>
        </div>
      </div>

      <!-- Viaje del documento (firma) -->
      <div class="sign-journey" *ngIf="isSignJourney" aria-hidden="true">
        <div class="sign-journey__track">
          <div class="sign-journey__line">
            <span
              class="sign-journey__line-fill"
              [style.width.%]="lineFillPercent">
            </span>
          </div>
          <div
            class="sign-journey__step"
            *ngFor="let step of journeySteps; let i = index"
            [class.is-done]="isStepDone(i)"
            [class.is-active]="isStepActive(i)"
            [class.is-pending]="!isStepDone(i) && !isStepActive(i)">
            <span class="sign-journey__node">
              <i class="fas" [ngClass]="isStepDone(i) ? 'fa-check' : step.icon" aria-hidden="true"></i>
            </span>
            <span class="sign-journey__label">{{ step.label }}</span>
          </div>
          <div
            class="sign-journey__packet"
            [ngStyle]="packetStyle"
            aria-hidden="true">
            <i class="fas fa-file-alt"></i>
          </div>
        </div>
      </div>

      <div class="loading-text" [class.loading-text--sign]="isSignJourney">
        <p class="loading-message">{{mensaje}}</p>

        <div class="sign-meta" *ngIf="isSignJourney && fileName">
          <span class="sign-meta__file" [attr.title]="fileName">
            <i class="fas fa-file" aria-hidden="true"></i>
            {{ fileName }}
            <ng-container *ngIf="fileSizeLabel"> · {{ fileSizeLabel }}</ng-container>
          </span>
        </div>

        <p class="sign-tip" *ngIf="isSignJourney">{{ currentTip }}</p>

        <p class="sign-note" *ngIf="isSignJourney">
          Archivos grandes pueden tardar varios minutos. No cierres esta ventana.
        </p>

        <div class="loading-bar" *ngIf="!isSignJourney" aria-hidden="true">
          <span class="loading-bar-fill"></span>
        </div>
      </div>
    </div>
  </div>
</div>
